import React, { useEffect, useState } from "react";
import axios from "axios";
import serverURL from "../config";
import { useNavigate } from "react-router-dom";
import CategoryModal from "../components/CategoryModal";
import CardActions from "../components/CardActions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


const Category = () => {
    const [category, setCategory] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [categoryTitle, setCategoryTitle] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);

    const navigate = useNavigate();

    const fetchCategory = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${serverURL}/categories`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setCategory(response.data);
        } catch (error) {
            console.error('Failed to fetch category:', error);
        }
    }

    useEffect(() => {
        fetchCategory();
    }, []);

    const openCategoryModal = () => {
        setModalOpen(true);
    };

    const closeCategoryModal = () => {
        setModalOpen(false);
        setSelectedCategory(null);
    };

    const handleAdd = () => {
        openCategoryModal();
        setCategoryTitle('Add Category');
    }

    const handleEdit = (item) => {
        setSelectedCategory(item);
        openCategoryModal();
        setCategoryTitle('Edit Category')
    }

    const handleDelete = (item) => {
        setSelectedCategory(item);
        openCategoryModal();
        setCategoryTitle('Delete Category')
    }

    const handleViewDetails = (event) => {
        navigate(`/categories/${event.id}/${encodeURIComponent(event.category_name)}`, {
            state: {
                description: event.description,
                isActive: event.is_active,
            },
        });
    };

    return (
        <div className="flex flex-col min-h-screen bg-campus-bg">
            <main className="flex-grow p-6">

                <div className="flex justify-end mb-5">
                    <button
                        onClick={handleAdd}
                        className="hover-expand-container bg-campus-primary text-white rounded-lg font-medium cursor-pointer h-10 px-3 hover:bg-campus-primary-dark shadow-sm hover:shadow-lg focus-visible:outline-none"
                        style={{
                            '--expand-width': '10rem',
                            '--expand-padding': '0 1rem'
                        }}
                        aria-label="Add Category"
                    >
                        <span className="hover-expand-icon">
                            <FontAwesomeIcon icon={faPlus} className="w-4 h-4" />
                        </span>
                        <span className="hover-expand-content text-sm" aria-hidden="true">
                            Add Category
                        </span>
                    </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {category.map((event) => (
                        <div
                            key={event.id}
                            className="bg-campus-surface p-4 rounded-card shadow-card border border-campus-border card-hover-effect"
                        >
                            <div className={`inline-flex items-center text-white text-xs font-bold py-1 px-2 rounded-full mb-2 ${event.is_active ? 'bg-campus-success' : 'bg-campus-error'}`}>
                                {event.is_active ? 'Active' : 'Inactive'}
                            </div>
                            <h3 className="text-lg font-semibold text-campus-text-primary">{event.category_name}</h3>
                            <p className="text-campus-text-body h-12 text-sm mt-1">Description: {event.description}</p>
                            <CardActions
                                onViewDetails={() => handleViewDetails(event)}
                                onEdit={() => handleEdit(event)}
                                onDelete={() => handleDelete(event)}
                            />
                        </div>
                    ))}
                </div>
            </main>
            {/* Modal */}
            {modalOpen && (
                <CategoryModal title={categoryTitle} category={selectedCategory} closeCategoryModal={closeCategoryModal} fetchCategory={fetchCategory} />
            )}
        </div>
    );
};

export default Category;
